import React, { useEffect, useState } from 'react';
import { all_routes } from '../../../../core/data/routes/all_routes';
import { Link, useNavigate } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import ImageWithBasePath from '../../../../core/img/ImageWithBasePath';
import { computerServices } from '../../../../core/data/json/computerServices';
import { removals } from '../../../../core/data/json/removals';
import { manVan } from '../../../../core/data/json/manvan';
import { furniture } from '../../../../core/data/json/furniture';
import { electrical } from '../../../../core/data/json/electrical';
import { construction } from '../../../../core/data/json/construction';
import { plumbing } from '../../../../core/data/json/plumbing';
import { moreServices } from '../../../../core/data/json/moreService';
import { collection, getDocs, limit, query } from 'firebase/firestore';
import { db } from '../../../../firebase';
import { Spin } from 'antd';
const PopularSection = () => {
  const routes = all_routes;
  const imgslideroption = {
    dots: false,
    nav: false,
    infinite: true,
    speed: 500,
    swipe: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 0,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  const slideslideroption = {
    dots: true,
    nav: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    draggable: true,
    tochMove: true,
    swipe: true,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 0,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  //Fetch the Services Start----------------
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(false);

  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();


  // Fetch services from Firestore
  const fetchServices = async () => {
    setLoading(true);
    try {
      const q = query(collection(db, 'services'), limit(12)); //limitt
      const servicesSnapshot = await getDocs(q);
      const servicesList = servicesSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setServices(servicesList);
    } catch (error) {
      // console.error('Error fetching services:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchServices();
  }, []);
  //Fetch the Services End------------------

  // Fetch categories from Firestore
  const fetchCategories = async () => {
    setLoading(true);
    try {
      const q = query(collection(db, "categories"), limit(12)); // Ensure "categories" is the correct Firestore collection
      const categoriesSnapshot = await getDocs(q);
      const categoriesList = categoriesSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setCategories(categoriesList);
    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  // Navigate to Categories Details Page with Category Data
  const handleBookNow = (category) => {
    console.log("testing_click")
    navigate(routes.serviceDetails1, { state: { category } });
  };


  return (
    <>
      {/* Popular Section */}
      <section className="section popular-section"
      style={{
        backgroundImage: `url("https://i.postimg.cc/mZ5fxsvz/bg.jpg")`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div
              className="col-lg-6 text-center wow fadeInUp"
              data-wow-delay="0.2s"
            >
              <div className="section-header text-center mb-4">
                <h2 className="mb-1" style={{color: '#fff'}}>
                  Our Popular{' '}
                  <span className="text-linear-primary">Services</span>
                </h2>
                <p className="sub-title" style={{color: '#fff'}}>
                  Each listing is designed to be clear and concise, providing
                  customers
                </p>
              </div>
            </div>
          </div>
          {/* Fetch the lbl of the Service */}
          <ul className="nav nav-tabs nav-tabs-solid justify-content-center mb-4">
            {loading ? (
              <li className="nav-item mb-3">
                <span className="nav-link" style={{color: '#fff'}}>Loading...</span>
              </li>
            ) : (
              services.map((service, index) => (
                <li key={service.id} className="nav-item mb-3">
                  <Link className="nav-link" to="#furniture" data-bs-toggle="tab"
                  style={{color: '#fff'}}
                  // className={`nav-link ${index === 0 ? "active" : ""}`}
                  // to={`#${service.lbl.toLowerCase().replace(/\s+/g, "-")}`}
                  // data-bs-toggle="tab"
                  >
                    {service.lbl}
                  </Link>
                </li>
              ))
            )}
          </ul>
          {/* <ul className="nav nav-tabs nav-tabs-solid justify-content-center mb-4">
            <li className="nav-item mb-3">
              <Link
                className="nav-link active"
                to="#computer-service"
                data-bs-toggle="tab"
              >
                Computer Service
              </Link>
            </li>
            <li className="nav-item mb-3">
              <Link className="nav-link" to="#removals" data-bs-toggle="tab">
                Removals
              </Link>
            </li>
            <li className="nav-item mb-3">
              <Link className="nav-link" to="#man" data-bs-toggle="tab">
                Man &amp; Van
              </Link>
            </li>
            <li className="nav-item mb-3">
              <Link className="nav-link" to="#furniture" data-bs-toggle="tab">
                Furniture Assembly
              </Link>
            </li>
            <li className="nav-item mb-3">
              <Link className="nav-link" to="#electrical" data-bs-toggle="tab">
                Electrical
              </Link>
            </li>
            <li className="nav-item mb-3">
              <Link
                className="nav-link"
                to="#construction"
                data-bs-toggle="tab"
              >
                Construction
              </Link>
            </li>
            <li className="nav-item mb-3">
              <Link className="nav-link" to="#plumbing" data-bs-toggle="tab">
                Plumbing
              </Link>
            </li>
            <li className="nav-item mb-3">
              <Link
                className="nav-link"
                to="#more-service"
                data-bs-toggle="tab"
              >
                More Services
              </Link>
            </li>
          </ul> */}
          <div className="tab-content">
            <div className="tab-pane fade active show" id="computer-service">
              {loading ? (
                <div className="row">
                  <div className="col-lg-3 col-md-3 col-sm-6">
                    <div className="card p-0">
                      <div className="card-body p-0">
                        <div className="img-sec w-100 d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                          <Spin />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-6">
                    <div className="card p-0">
                      <div className="card-body p-0">
                        <div className="img-sec w-100 d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                          <Spin />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-6">
                    <div className="card p-0">
                      <div className="card-body p-0">
                        <div className="img-sec w-100 d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                          <Spin />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-6">
                    <div className="card p-0">
                      <div className="card-body p-0">
                        <div className="img-sec w-100 d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                          <Spin />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <Slider {...imgslideroption} className="main-slider owl-carousel nav-center">
                  {categories.map((category, index) => (
                    <div className="service-item wow fadeInUp" data-wow-delay="0.2s"
                      //key={category.id}
                      onClick={() => handleBookNow(category)}>
                      <div className="service-img">
                        <Slider {...slideslideroption} className="img-slider home-sliders owl-carousel nav-center">
                          <div className="slide-images">
                            <Link to={routes.serviceDetails1}>
                              <img
                                src={category.category_view_icon || "placeholder-image.jpg"}
                                className="img-fluid"
                                alt="Category"
                              />
                            </Link>
                          </div>
                        </Slider>
                        <div className="fav-item d-flex align-items-center justify-content-between w-100">
                          <Link to="#" className="avatar avatar-md">
                            <img src={category.icon || "placeholder-avatar.jpg"} className="rounded-circle" alt="User" />
                          </Link>
                          <Link to="#" className="fav-icon">
                            <i className="ti ti-heart" />
                          </Link>
                        </div>
                      </div>
                      <div className="service-content">
                        <h6 className="mb-1 text-truncate">
                          <Link to={routes.serviceDetails1}>{category.title || "Untitled Category"}</Link>
                        </h6>
                        <div className="d-flex align-items-center justify-content-between">
                          <p className="fs-14 mb-0">
                            <i className="ti ti-star-filled text-warning me-1" /> 4.9
                          </p>
                          <small>₹ {category.price ? category.price.toFixed(2) : "Price not available"}</small>
                        </div>
                      </div>
                    </div>
                  ))}
                </Slider>
              )}
            </div>
          </div>



          <div className="row">
            <div className="col-md-12">
              <div className="text-center wow fadeInUp" data-wow-delay="0.2s">
                <Link to={routes.search} className="btn btn-dark">
                  View All
                  <i className="ti ti-arrow-right ms-2" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* /Popular Section */}
    </>
  );
};

export default PopularSection;
